import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";
import HistoryIcon from "@mui/icons-material/History";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { applyFilter } from "../../redux/search";

const SaleRowContextMenu = (props) => {
  const dispatch = useDispatch();

  const onCopyClick = async (event) => {
    event.stopPropagation();
    await navigator.clipboard.writeText(props.targetValue);
    props.onClose();
  };

  const onEditClick = (event) => {
    event.stopPropagation();
    props.onEdit();
    props.onClose();
  };

  const onHistoryClick = (event) => {
    event.stopPropagation();
    if (props.tkt) {
      dispatch(applyFilter({ id: "tkt", value: props.tkt }));
    } else if (props.pnr) {
      dispatch(applyFilter({ id: "pnr", value: props.pnr }));
    }
    props.onClose();
  };

  return (
    <Menu
      className={props.className}
      open={props.contextMenu !== null}
      onClose={props.onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        props.contextMenu !== null
          ? { top: props.contextMenu.mouseY, left: props.contextMenu.mouseX }
          : undefined
      }
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      <MenuItem onClick={onCopyClick}>
        <ListItemIcon>
          <ContentCopyIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Copy</ListItemText>
      </MenuItem>
      <Divider />
      <MenuItem onClick={onEditClick} disabled={!props.canEdit}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Edit</ListItemText>
      </MenuItem>
      <MenuItem disabled={!props.tkt && !props.pnr} onClick={onHistoryClick}>
        <ListItemIcon>
          <HistoryIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>History</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default styled(SaleRowContextMenu)(
  ({ theme }) => `
  & .MuiPaper-root {
    width: 150px;
  }
`,
);
